import React, { useState } from "react";
import { Col } from "common/components";
import InvestigationEventList from "security-app/components/Investigations/Details/ProceduresSegment/Procedures/Modals/InvestigationEventList/List";
import Description from "security-app/components/Investigations/Details/ProceduresSegment/Procedures/description";
import BulkActions from "./bulk-actions";
function useTableComponents() {
  const renderExpanded = (inStep) => /* @__PURE__ */ React.createElement(Col, { $gap: 0 }, /* @__PURE__ */ React.createElement(Description, { title: "Step Description:", description: inStep.step.description, isOpen: true }), /* @__PURE__ */ React.createElement(InvestigationEventList, { eventIds: inStep.event_ids, step: inStep.step }));
  const expandedSections = {
    restFieldsExpandedSection: {
      title: null,
      content: renderExpanded,
      disableHeader: true
    }
  };
  const [selectedStepsMap, setSelectedStepsMap] = useState();
  const bulkSelection = {
    onChangeSelection: (selectedItemsIds, list) => {
      setSelectedStepsMap((cur) => {
        const uniqueSelectedIds = [...new Set(selectedItemsIds)];
        const stepsMap = Object.fromEntries(
          list.map((inStep) => {
            var _a, _b;
            return [
              inStep.id,
              {
                stepId: inStep.step.id,
                stepActionType: (_b = (_a = inStep.step.action) == null ? void 0 : _a.config) == null ? void 0 : _b.type,
                eventIds: inStep.event_ids
              }
            ];
          })
        );
        return Object.fromEntries(
          uniqueSelectedIds.map((inStepId) => {
            var _a;
            return [inStepId, (_a = cur == null ? void 0 : cur[inStepId]) != null ? _a : stepsMap == null ? void 0 : stepsMap[inStepId]];
          })
        );
      });
    },
    actions: /* @__PURE__ */ React.createElement(BulkActions, { selectedStepsMap })
  };
  return {
    bulkSelection,
    expandedSections
  };
}
export default useTableComponents;
